import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, renderSlot } from "vue";
import { cn } from "../../../../lib/utils.js";
import { useFormField } from "./useFormField.js";
const _hoisted_1 = ["id"], _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormDescription",
  props: {
    class: {}
  },
  setup(__props) {
    const props = __props, formField = useFormField();
    return (_ctx, _cache) => (openBlock(), createElementBlock("p", {
      id: unref(formField).formDescriptionId,
      "data-slot": "form-description",
      class: normalizeClass(unref(cn)("text-muted-foreground text-sm", props.class))
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_1));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormDescription.js.map
